// extracted by mini-css-extract-plugin
export default {"premium-folder-icon":"_9U4Yn","premiumFolderIcon":"_9U4Yn","widget-paywall-locked":"_3m1x7","widgetPaywallLocked":"_3m1x7"};